module.exports = __webpack_public_path__ + "static/img/hugo.cc4827c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hugo.svg
// module id = cy2y
// module chunks = 1